var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVaulticon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 81,
  height: 72,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#vaulticon_svg__a)",
  d: "M24.447 33.81a6.67 6.67 0 0 1 6.667-6.667 6.67 6.67 0 0 1 6.667 6.667 6.67 6.67 0 0 1-6.667 6.667 6.67 6.67 0 0 1-6.667-6.667m26.669 0c0 11.043-8.96 20.002-20.002 20.002-11.043 0-20.002-8.96-20.002-20.002 0-11.043 8.96-20.002 20.002-20.002 11.043 0 20.002 8.96 20.002 20.002M31.114 20.475c-7.487 0-13.335 5.848-13.335 13.335 0 7.362 5.848 13.335 13.335 13.335 7.362 0 13.335-5.973 13.335-13.335 0-7.487-5.973-13.335-13.335-13.335m37.781 4.445a6.68 6.68 0 0 1-3.333 5.779v15.334a3.326 3.326 0 0 1-3.334 3.334 3.326 3.326 0 0 1-3.334-3.334V30.7a6.669 6.669 0 0 1 3.334-12.446 6.67 6.67 0 0 1 6.667 6.667M0 9.363C0 4.453 3.98.473 8.89.473h62.228c4.903 0 8.89 3.98 8.89 8.89v48.894c0 4.903-3.987 8.89-8.89 8.89v1.11a3.326 3.326 0 0 1-3.334 3.334 3.326 3.326 0 0 1-3.334-3.333v-1.111H15.557v1.11a3.326 3.326 0 0 1-3.334 3.334 3.33 3.33 0 0 1-3.333-3.333v-1.111c-4.91 0-8.89-3.987-8.89-8.89zm6.667 0v48.894c0 1.222.995 2.222 2.223 2.222h62.228c1.222 0 2.222-1 2.222-2.222V9.363c0-1.227-1-2.222-2.222-2.222H8.89a2.22 2.22 0 0 0-2.223 2.222"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "vaulticon_svg__a",
  x1: 80.007,
  x2: 0,
  y1: 36.032,
  y2: 36.032,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00CBA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#09F"
})))));
export default SvgVaulticon;